'use strict';

/** @type {import('./functionCall')} */
module.exports = Function.prototype.call;



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/call-bind-apply-helpers/functionCall.js
// module id = ../../../../call-bind-apply-helpers/functionCall.js
// module chunks = 5